// import { useEffect, useRef } from "react";
// import { useEnv } from "../chat/utils";
// import "./livechat.style.css";

// export default function GenesysChat() {
//   const scriptLoaded = useRef(false);
//   const { isValid, values, error } = useEnv(["GENESYS_LIVECHAT_ENVIRONMENT", "GENESYS_LIVECHAT_DEPLOYMENT_ID"]);

//   if (!isValid) {
//     console.error("LiveChat configuration is invalid:", error);
//     return null;
//   }

//   const environment = values.GENESYS_LIVECHAT_ENVIRONMENT;
//   const deploymentId = values.GENESYS_LIVECHAT_DEPLOYMENT_ID;

//   useEffect(() => {
//     if (scriptLoaded.current) return;

//     try {
//       window["_genesysJs"] = "Genesys";
//       window["Genesys"] =
//         window["Genesys"] ||
//         function () {
//           (window["Genesys"].q = window["Genesys"].q || []).push(arguments);
//         };
//       window["Genesys"].t = Date.now();
//       window["Genesys"].c = { environment: environment, deploymentId: deploymentId };

//       const script = document.createElement("script");
//       script.type = "text/javascript";
//       script.async = true;
//       script.charset = "utf-8";
//       script.src = "https://apps.mypurecloud.jp/genesys-bootstrap/genesys.min.js";
//       script.onerror = () => {
//         console.error("Failed to load Genesys script");
//       };

//       document.head.appendChild(script);
//       scriptLoaded.current = true;
//     } catch (error) {
//       console.error("Error loading Genesys script:", error);
//     }
//   }, [environment, deploymentId]);

//   return null;
// }

// //--------------------------------------------
import { useEffect, useRef } from "react";

export default function CXoneGuide() {
  const loadedRef = useRef(false);

  useEffect(() => {
    if (loadedRef.current) return;

    const loaderUrl = "https://web-modules-de-jp1.niceincontact.com/loader/1/loader.js";
    const tenantId = "1197";

    if (document.querySelector('script[data-cxone-loader="true"]')) {
      loadedRef.current = true;
      return;
    }

    const n = "cxone";
    window.CXoneDfo = n;
    window[n] =
      window[n] ||
      function () {
        (window[n].q = window[n].q || []).push(arguments);
      };
    window[n].u = loaderUrl;

    const s = document.createElement("script");
    s.type = "module";
    s.async = true;
    s.src = `${loaderUrl}?${Math.round(Date.now() / 1e3 / 3600)}`;
    s.setAttribute("data-cxone-loader", "true");

    s.onload = () => {
      window.cxone("init", tenantId);

      window.cxone("guide", "init", {
        resetRulesOnNewPage: true,
        templateId: "4ae6e86a-86f7-4c5e-b54f-ce180e171f8b",
      });

      window.cxone("guide", "setButtonSize", "50px"); //
      window.cxone("guide", "setOffsetX", "16px"); // ปรับได้ตามต้องการ
      window.cxone("guide", "setOffsetY", "16px"); //

      window.cxone("chat", "hideAssignedAgent");

      window.cxone(
        "guide",
        "setCustomCss",
        `
      .be-template.svelte-1bzqhg3 {
        z-index: 800 !important;
      }

      .be-template {
        z-index: 800 !important;
      }

        /* ถ้าจะทำปุ่มชิดซ้าย/จัดระยะ ให้ทำในนี้ */
        #cxone-guide-container button {
          margin-left: 0 !important;
          margin-right: auto !important;
        }

        @media (max-width: 768px) {
          #cxone-guide-container { display: none !important; }
          [data-selector="GUIDE_MENU_BUTTON"] { display: none !important; }
        }
          
        @media (max-width: 1024px),
               (max-width: 1366px) and (orientation: landscape) and (any-pointer: coarse) {
          #cxone-guide-container { display: none !important; }
          [data-selector="GUIDE_MENU_BUTTON"] { display: none !important; }
        }
      `
      );
    };

    s.onerror = () => console.error("Failed to load CXone loader:", s.src);

    document.head.appendChild(s);
    loadedRef.current = true;
  }, []);

  return null;
}
